import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import CustomDialogFooter from "../../../shared/components/CustomDialogFooter";

function AddDeviceDialog({
  handleAddDeviceDialogOpen,
  handlePairingStatus,
  state,
}) {
  return (
    <Stack flexDirection="column">
      <Box p="24px" pb="16px">
        <Stack alignItems="center" justifyContent="center">
          <img
            src="/icons/ic_device_tick.svg"
            alt="device tick"
            width="36px"
            height="36px"
          />
          <Typography
            fontWeight={600}
            padding="15px"
            fontSize="24px"
            textAlign="center"
          >
            Device Added Successfully!
          </Typography>
        </Stack>
        <Stack alignItems="center" gap="16px">
          <Typography fontSize="14px">Device Code:</Typography>
          <Typography fontSize={32} fontWeight={600} letterSpacing={10}>
            {state?.code}
          </Typography>

          <Typography align="center" fontSize="14px" color="text.secondary">
            Your device has been successfully added. You can use this code to
            initiate the pairing process.
          </Typography>
        </Stack>
      </Box>
      <CustomDialogFooter
        onSubmit={() => handleAddDeviceDialogOpen(false)}
        handleClose={() => handleAddDeviceDialogOpen(false)}
        hasCancelButton={false}
        submitButton="Ok"
        sx={{ px: "24px" }}
      />
    </Stack>
  );
}

export default AddDeviceDialog;
